<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('LULUSAN')" :class="{'form-group': true, 'has-error': errors.has('id_pendidikan')}">
        <label class="col-md-3"><span class="required-label">*</span>Lulusan Perguruan Tinggi</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_pendidikan"
            class="form-control"
            v-model="model.id_pendidikan"
            v-validate="isExist('LULUSAN') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Lulusan</option>
            <option v-for="pendidikan in options.pendidikan" :key="pendidikan.id_pendidikan" :value="pendidikan.id_pendidikan">
              {{ pendidikan.nama_pendidikan }}
            </option>
          </select>
          <span v-show="errors.has('id_pendidikan')" class="error-label">Pilih Lulusan</span>
        </div>
      </div>
      <div v-show="isExist('NM_PT')" :class="{'form-group': true, 'has-error': errors.has('nama_pt')}">
        <label class="col-md-3"><span class="required-label">*</span>Nama Perguruan Tinggi</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nama_pt"
            placeholder="Nama Perguruan Tinggi"
            class="form-control"
            maxlength="100"
            v-model="model.nama_pt"
            v-validate="isExist('NM_PT') ? 'required' : ''"
          >
          <span v-show="errors.has('nama_pt')" class="error-label">Isi Nama Perguruan Tinggi</span>
        </div>
      </div>
      <div v-show="isExist('ASAL_JURUSAN')" :class="{'form-group': true, 'has-error': errors.has('asal_jurusan')}">
        <label class="col-md-3"><span class="required-label">*</span>Asal Jurusan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="asal_jurusan"
            placeholder="Asal Jurusan"
            class="form-control"
            maxlength="100"
            v-model="model.asal_jurusan"
            v-validate="isExist('ASAL_JURUSAN') ? 'required' : ''"
          >
          <span v-show="errors.has('asal_jurusan')" class="error-label">Isi Asal Jurusan</span>
        </div>
      </div>
      <div v-show="isExist('AKREDITASI_JURUSAN')" :class="{'form-group': true, 'has-error': errors.has('akreditasi_jurusan')}">
        <label class="col-md-3"><span class="required-label">*</span>Akreditasi Jurusan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="akreditasi_jurusan"
            placeholder="Akreditasi Jurusan"
            class="form-control"
            maxlength="30"
            v-model="model.akreditasi_jurusan"
            v-validate="isExist('AKREDITASI_JURUSAN') ? 'required' : ''"
          >
          <span v-show="errors.has('akreditasi_jurusan')" class="error-label">Isi Akreditasi Jurusan</span>
        </div>
      </div>
      <div v-show="isExist('TH_IJAZAH')" :class="{'form-group': true, 'has-error': errors.has('tahun_ijazah')}">
        <label class="col-md-3"><span class="required-label">*</span>Tahun Ijazah</label>
        <div class="col-md-6">
          <input
            type="text"
            name="tahun_ijazah"
            placeholder="Tahun Ijazah"
            class="form-control"
            maxlength="8"
            v-model="model.tahun_ijazah"
            v-validate="isExist('TH_IJAZAH') ? 'required' : ''"
          >
          <span v-show="errors.has('tahun_ijazah')" class="error-label">Isi Tahun Ijazah</span>
        </div>
      </div>
      <div v-show="isExist('IPK')" :class="{'form-group': true, 'has-error': errors.has('ipk')}">
        <label class="col-md-3"><span class="required-label">*</span>IPK</label>
        <div class="col-md-6">
          <input
            type="text"
            name="ipk"
            placeholder="Format ipk --> x.xx"
            class="form-control"
            maxlength="5"
            v-model="model.ipk"
            v-validate="isExist('IPK') ? 'required' : ''"
          >
          <span v-show="errors.has('ipk')" class="error-label">Isi IPK</span>
        </div>
      </div>
      <div v-show="isExist('AKREDITASI_UNIVERSITAS')" :class="{'form-group': true, 'has-error': errors.has('akreditasi_universitas')}">
        <label class="col-md-3"><span class="required-label">*</span>Akreditasi Universitas</label>
        <div class="col-md-6">
          <input
            type="text"
            name="akreditasi_universitas"
            placeholder="Akreditasi Universitas"
            class="form-control"
            maxlength="30"
            v-model="model.akreditasi_universitas"
            v-validate="isExist('AKREDITASI_UNIVERSITAS') ? 'required' : ''"
          >
          <span v-show="errors.has('akreditasi_universitas')" class="error-label">Isi Akreditasi Universitas</span>
        </div>
      </div>
      <div v-show="isExist('SCAN_IJAZAH')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Ijazah / Surat Keterangan Lulus (SKL)</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointIjazah"
            :headers="header"
            name="ijazah"
            :data="dataUpload"
            :on-error="handleIjazahError"
            :on-success="handleIjazahSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.file_ijazah"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png dan tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
          <div v-if="ijazahUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="ijazahUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
      <div v-show="isExist('SCAN_TRANSKRIP')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Transkrip Nilai</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointTranskrip"
            :headers="header"
            name="transkrip"
            :data="dataUpload"
            :on-error="handleTranskripError"
            :on-success="handleTranskripSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.file_transkrip"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png dan tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
          <div v-if="transkripUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="transkripUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
    </form>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import { baseURL } from '@/api/data'
import Options from '@/helper/options'

export default {
  data () {
    return {
      init: false,
      loading: false,
      sending: false,
      ijazahUrl: null,
      transkripUrl: null,
      batasIpk: 0,
      model: {
        id_pendidikan: null,
        nama_pt: null,
        asal_jurusan: null,
        tahun_ijazah: null,
        ipk: null,
        akreditasi_jurusan: null,
        akreditasi_universitas: null
      },
      savedModel: null,
      file: {
        file_ijazah: [],
        file_transkrip: []
      },
      options: {
        pendidikan: []
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  computed: {
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    kodePenawaran () {
      return this.$store.getters.getAuthData.data.mhs_jalur.kode_penawaran
    },
    docEndPointIjazah () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_riwayat_pendidikan_s2/ijazah'
      } else {
        return 'test'
      }
    },
    docEndPointTranskrip () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_riwayat_pendidikan_s2/transkrip'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(17).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              if (this.isExist('IPK')) {
                this.batasIpk > parseFloat(this.model.ipk) ? reject({message: 'pastikan format ipk x.xx & minimal ipk ' + this.batasIpk}) : false
              }
              let ijazahUploaded = this.file.file_ijazah.length > 0
              let transkripUploaded = this.file.file_transkrip.length > 0
              !ijazahUploaded && this.isExist('SCAN_IJAZAH') ? reject({message: 'belum ada file ijazah'}) : false
              !transkripUploaded && this.isExist('SCAN_TRANSKRIP') ? reject({message: 'belum ada file transkrip'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 17)
    },
    async initData () {
      if (!this.init) {
        this.options.pendidikan = await Options.getOptionsPendidikan()
        this.getData()
        this.getBatasIpk()
        this.isExist('SCAN_TRANSKRIP') ? this.getTranskrip() : false
        this.isExist('SCAN_IJAZAH') ? this.getIjazah() : false
        this.init = true
      }
    },
    handleIjazahError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.file_ijazah = [{name: 'ijazah_' + this.nomorPendaftar + '.pdf'}]
        this.ijazahUrl = 'Test'
      }
    },
    handleTranskripError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.file_transkrip = [{name: 'transkrip_' + this.nomorPendaftar + '.pdf'}]
        this.transkripUrl = 'Test'
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleIjazahSuccess (res, file) {
      this.getIjazah()
      alert('upload sukses')
    },
    handleTranskripSuccess (res, file) {
      this.getTranskrip()
      alert('upload sukses')
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpeg'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf/jpg/png') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 MB') : false
      return isMIME && isLt2M
    },
    getData () {
      this.loading = true
      api.get('/v1/data_riwayat_pendidikan_s2/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            let data = responseData.data
            this.model = data
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    getTranskrip () {
      api.get('/v2/data_riwayat_pendidikan_s2/transkrip/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.file_transkrip = [{name: 'transkrip_' + this.nomorPendaftar + '.pdf'}]
            this.transkripUrl = responseData.url
          }
        })
    },
    getIjazah () {
      api.get('/v2/data_riwayat_pendidikan_s2/ijazah/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.file_ijazah = [{name: 'ijazah_' + this.nomorPendaftar + '.pdf'}]
            this.ijazahUrl = responseData.url
          }
        })
    },
    getBatasIpk () {
      api.get('/v1/batas_ipk/' + this.kodePenawaran)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.batasIpk = responseData.data.ipk
          }
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/data_riwayat_pendidikan_s2', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                this.sending = false
                this.savedModel = model
                resolve(response.data)
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/RiwayatPendidikanS2.vue